import * as t from 'io-ts';

export const CustomerDynamicType = t.interface({
    id: t.string,
    name: t.string
});

export type Customer = t.TypeOf<typeof CustomerDynamicType>;
